module.exports = __webpack_public_path__ + "static/assets/32c871e1e3a4aea9a8975e91caef2b0a.png";